/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fertilizer_WeightInputs */

const vi_fertilizer_weight = /** @type {(inputs: Fertilizer_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khối lượng`)
};

/**

* @param {Fertilizer_WeightInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fertilizer_weight = /** @type {((inputs?: Fertilizer_WeightInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fertilizer_WeightInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fertilizer_weight(inputs)
});